import { render, staticRenderFns } from "./EditScene.vue?vue&type=template&id=61c204b1&scoped=true&"
import script from "./EditScene.vue?vue&type=script&lang=js&"
export * from "./EditScene.vue?vue&type=script&lang=js&"
import style0 from "./EditScene.vue?vue&type=style&index=0&id=61c204b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c204b1",
  null
  
)

export default component.exports